<template>
  <div class="zmanim-solar-path__node" />
</template>

<script>
export default {
  name: 'ZmanimSolarPathNode'
}
</script>

<style scoped>
.zmanim-solar-path__node {
  display: block;
  height: 2.5px;
  width: 2.5px;
  border-radius: 50%;
  background: transparent; /* #ff8511; */
}
</style>
